import { useParseInvoiceMutation } from "../app/vaApi/vaApi";
import {
  normalizeParseResult,
  getVaInvoiceErrorMessage,
} from "../helpers/vaInvoiceUtils";
import { saveParseResult } from "../helpers/vaParseStorage";

export function useParseInvoice() {
  const [parseInvoice, state] = useParseInvoiceMutation();

  const parse = async (file) => {
    try {
      const result = await parseInvoice(file).unwrap();
      const normalized = normalizeParseResult(result);
      if (!normalized?.parseId) {
        throw { status: 502, data: { message: "Could not read invoice, try again" } };
      }
      saveParseResult(normalized.parseId, normalized);
      return normalized;
    } catch (err) {
      throw {
        ...err,
        data: {
          ...err?.data,
          message: getVaInvoiceErrorMessage(err),
        },
      };
    }
  };

  return {
    parse,
    isUploading: state.isLoading,
    error: state.error,
    reset: state.reset,
  };
}
